var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "whiteBlack",
    attrs: {
      "id": "whiteBlack"
    }
  }, [_c('pro-table', _vm._b({}, 'pro-table', _vm.config, false))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };